export default __webpack_public_path__ + "static/media/excel.0ae4a565.png";